import { render, staticRenderFns } from "./CustomerNoteRaw.vue?vue&type=template&id=f13e9f90&"
import script from "./CustomerNoteRaw.vue?vue&type=script&lang=ts&"
export * from "./CustomerNoteRaw.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports